import {
  ScheduleEntryState,
  Task,
  Timestamp,
  UpcomingPeriod,
  UpcomingPeriodTypes,
} from '@griply/types';

import { getScheduleByDate } from '../schedules/get-schedule-by-date';

export type GetPeriodTargetOptions = {
  today: Timestamp;
};

export type PeriodTarget = {
  plannedCount: number;
  targetCount: number;
  showTargetCounter: boolean;
  showRestoreAction: boolean;
};

export const getPeriodTarget = (
  task: Task,
  period: UpcomingPeriod,
  { today }: GetPeriodTargetOptions,
): PeriodTarget => {
  const plannedCount = period.days.filter(
    (day) =>
      day.entry &&
      !day.entry.isGeneratedFrequencyEntry &&
      day.entry.state !== ScheduleEntryState.Skip,
  ).length;

  if (!task.schedules?.length || period.type === UpcomingPeriodTypes.Overdue) {
    return {
      plannedCount,
      targetCount: 0,
      showTargetCounter: false,
      showRestoreAction: false,
    };
  }

  const activeSchedule = getScheduleByDate(task.schedules, {
    date: period.date,
    today,
  });
  const targetCount = activeSchedule?.frequency?.count ?? 0;

  const showTargetCounter = !!plannedCount && !!targetCount;

  let showRestoreAction = false;
  if (targetCount) {
    const counts = period.days.reduce(
      (acc, day) => {
        if (day.entry && !day.entry.hidden) {
          acc.activeCount += 1;
        }
        if (day.entry?.hidden && day.entry.state === ScheduleEntryState.Skip) {
          acc.hiddenSkippedCount += 1;
        }
        return acc;
      },
      { activeCount: 0, hiddenSkippedCount: 0 },
    );
    showRestoreAction = !counts.activeCount && !!counts.hiddenSkippedCount;
  }

  return {
    plannedCount,
    targetCount,
    showTargetCounter,
    showRestoreAction,
  };
};
